import { Buffer } from 'buffer'
import { generateKey, xor } from './lib/xor'
import log from './lib/log-no-src'

export function showDiscord() {
    const key = generateKey(16)
    const xorString = xor(Buffer.from("cGx1c3JlZWQ=", "base64").toString("utf-8"), key)
    ;(window as any)["dStr"] = xorString
    ;(window as any)["dKey"] = key
    log("The string is at window.dStr.")
    log("The key is at window.dKey.")
    log("Hopefully not too hard, right...?")
    import(/* webpackChunkName: 'swal2' */'sweetalert2').then(({ default: Swal }) => {
        Swal.fire({
            title: 'Discord',
            customClass: {
                popup: 'animated bounceIn'
            },
            //text: `Discord: ${Buffer.from("UGx1c1JlZWQjMDAwMQ==", 'base64')}`
            html: 'If you need my Discord, check the browser console.'
        });
    })
}